import React, { Component } from "react";
import moment from "moment";
import { connect } from "react-redux";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

class ProductBookingTimingBox extends Component {
  formatPrice = (price) => {
    if (price == null) return "";
    const { settings, language } = this.props;
    const currency =
      language === "english"
        ? settings.currency_english
        : settings.currency_local;
    return `${price.toFixed(settings.currency_decimals)} ${currency}`;
  };

  renderInventoryAndPrice = (time) => {
    const { settings, language, themeColor, current_product } = this.props;
    const showInventory = settings.show_booking_slots_inventory;
    const showPrice = time.price > 0 && current_product.price !== time.price;

    if (!showInventory && !showPrice) {
      return null;
    }

    const inventoryColor =
      time.inventory < 5 ? "red" : time.inventory < 10 ? "orange" : themeColor;

    const inventoryText =
      language === "english"
        ? `${time.inventory} left`
        : `${time.inventory} متبقي`;

    const priceText = this.formatPrice(time.price);

    return (
      <div
        className="my-2"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: showInventory && showPrice ? "8px" : "0",
          direction: language === "arabic" ? "rtl" : "ltr",
        }}
      >
        {showInventory && (
          <span
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: inventoryColor,
            }}
          >
            {inventoryText}
          </span>
        )}

        {showInventory && showPrice && (
          <span style={{ fontSize: 10, color: "#999" }}>|</span>
        )}

        {showPrice && (
          <span
            style={{
              fontSize: 12,
              fontWeight: "bold",
              color: themeColor,
              display: "flex",
              alignItems: "center",
            }}
          >
            {priceText}
          </span>
        )}
      </div>
    );
  };

  render() {
    const {
      time,
      key,
      onClick,
      settings,
      language,
      themeColor,
      selectedTime,
      current_product,
    } = this.props;

    const isStyleTwoOrThree = (current_product.time_slots_style === 2) | 3; // Note: You might want to fix the bitwise OR | to logical OR || if unintended

    const containerStyle = {
      alignItems: "center",
      display: isStyleTwoOrThree ? "" : "flex",
      width: isStyleTwoOrThree ? "fit-content" : "",
      flexDirection: isStyleTwoOrThree ? "" : "column",
    };

    const slotStyle = {
      color: selectedTime === time.id && themeColor,
      border: `1px solid ${
        selectedTime === time.id ? themeColor : "#99999999"
      }`,
      borderRadius: 5,
      minWidth: "160px",
      padding: 15,
      display: "inline-block",
      marginRight: isStyleTwoOrThree && language === "english" ? 10 : 0,
      marginLeft: isStyleTwoOrThree && language === "arabic" ? 10 : 0,
    };

    return language === "english" ? (
      <div style={containerStyle}>
        <span
          key={key}
          value={time.id}
          onClick={onClick}
          className={`pointer ${selectedTime === time.id ? "active" : ""} ${
            isStyleTwoOrThree ? "" : "mx-4"
          }`}
          style={slotStyle}
        >
          {!time.all_day
            ? `${moment(time.start, "HH:mm:ss").format("h:mm A")}${
                settings.show_booking_end_slot
                  ? `-${moment(time.end, "HH:mm:ss").format("h:mm A")}`
                  : ""
              }`
            : `All Day`}
        </span>
        {this.renderInventoryAndPrice(time)}
      </div>
    ) : (
      <div style={containerStyle}>
        <span
          key={key}
          value={time.id}
          onClick={onClick}
          className={`pointer ${selectedTime === time.id ? "active" : ""} ${
            isStyleTwoOrThree ? "" : "mx-4"
          }`}
          style={{ ...slotStyle, direction: "rtl" }}
        >
          {!time.all_day
            ? `${moment(time.start, "HH:mm:ss")
                .format("h:mm A")
                .replace("AM", "ص")
                .replace("PM", "م")}${
                settings.show_booking_end_slot
                  ? ` الى ${moment(time.end, "HH:mm:ss")
                      .format("h:mm A")
                      .replace("AM", "ص")
                      .replace("PM", "م")}`
                  : ""
              }`
            : "اليوم بالكامل"}
        </span>
        {this.renderInventoryAndPrice(time)}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    settings: state.store.store.settings,
    current_product: state.store.current_product,
  };
};

export default connect(mapStateToProps)(ProductBookingTimingBox);
